import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import auth from "../../services/auth.js";
import teamdetails from "../../services/teams.js";
import companies from "../../services/companies.js";
import security from "../../services/security.js";
import env from "../../services/env.js";

class TeamdetailsController {
  constructor(
    $http,
    $localStorage,
    $state,
    AuthService,
    TeamsService,
    CompaniesService,
    SecurityService,
    $stateParams,
    CommonService,
    $rootScope,
    EnvService,
    $timeout,
    $location
  ) {
    this.name = "teamdetails";
    $localStorage.activeStateName = "teamdetails";

    if (!AuthService.isLoggedIn()) {
      $state.go("signin");
      return;
    }

    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$auth = AuthService;
    this.$teams = TeamsService;
    this.$companies = CompaniesService;
    this.$security = SecurityService;
    this.$stateParams = $stateParams;
    this.$common = CommonService;
    this.$rootScope = $rootScope;
    this.$env = EnvService;
    this.$timeout = $timeout;
    this.currentPageNumber = 1;
    this.pages = [];
    this.currentUser = this.$auth.getUserData();
    this.currentPageNumber = 1;
    this.$location = $location;
    this.userDetailsAreLoading = false;
    this.user_query = {
      max: 20,
      offset: 0,
      sort: "firstName",
      order: "desc",
    };
    var _this = this;
    _this.loadJobblers(0, 100);
    _this.team_name = _this.$location.$$search.name;
    _this.remain_loading_count = 0;
    _this.setPagination(_this.$location.$$search.numberOfUsers);
    _this.setDisabledArrows();
  }

  loadJobblers() {
    var _this = this;

    if (this.userDetailsAreLoading === true) {
      return;
    }

    this.userDetailsAreLoading = true;

    let id = _this.$stateParams.teamId;
    _this.setLoader();

    console.log("queary params");
    console.dir(_this.user_query);

    _this.$companies.loadJobblersFromTeam(id, _this.user_query).then(
      function (response) {
        _this.userDetailsAreLoading = false;
        _this.jobblers = response.data;
        try {
          _this.jobblers.forEach(function (jobbler) {
            _this.addAttributes(jobbler);
          });
        } catch (err) {
          console.log("in looping error");
          console.dir(err);
        } finally {
          console.log("in the finally");
          console.dir(_this.jobblers);
          _this.unSetLoader();
          _this.fancyLoad();
        }
      },
      function (error) {
        _this.userDetailsAreLoading = false;
        _this.unSetLoader();
        _this.$timeout(function () {
          alert("Error loading team details. Please try again. If the problem persists please contact support.");
        }, 300);
      }
    );
  }

  fancyLoad() {
    this.$timeout(() => {
      $(".jobs-dashboard-container .jobs-dashboard-jobs-listing table.jobs-dashboard-jobs-table tbody tr").each(function (index) {
        $(this)
          .delay(index * 10)
          .show(50);
      });
    }, 200);
  }

  clickMagnify() {
    jQuery(".search-container").addClass("s-open");
    jQuery(".search-container").find('input[type="search"]').focus();
  }

  closeSearch() {
    jQuery(".search-container").removeClass("s-open");
    this.query = "";
  }

  addAttributes(jobbler) {
    var _this = this;
    try {
      if (jobbler.ssn) {
        jobbler.profile_pass = "Yes";
      } else {
        jobbler.profile_pass = "No";
      }
      if (jobbler.paymentInfos[0] && jobbler.paymentInfos[0].id) {
        jobbler.pay_pass = true;
        jobbler.pay_info = "Yes";
      } else {
        jobbler.pay_pass = false;
        jobbler.pay_info = "No";
      }
      if (jobbler.isVerified) {
        jobbler.veri_pass = true;
        jobbler.verified = "Yes";
      } else {
        jobbler.veri_pass = false;
        jobbler.verified = "No";
      }
    } catch (err) {
      console.log("addAttributes error");
      console.dir(err);
    }
  }

  setPagination(total) {
    var _this = this;
    let page_array = [];
    if (total) {
      for (var i = 0; i < Math.ceil(total / _this.user_query.max); i++) {
        page_array.push(i + 1);
      }
      _this.pages = page_array;
    }
  }

  paginate(page) {

    console.log("paginate");
    console.dir(page);

    var _this = this;
    if (_this.currentPageNumber === 1 && page === 0) {
      return;
    }
    if (_this.currentPageNumber === _this.pages.length && page === _this.pages.length + 1) {
      return;
    }
    _this.currentPageNumber = page;
    let max = _this.user_query.max;
    _this.user_query.offset = page * max - max;
    _this.loadJobblers();
  }

  setDisabledArrows() {
    var _this = this;
  }

  confirmRemoval(jobbler) {
    var _this = this;
    console.log("confirm removal");
    console.dir(jobbler);
    _this.$timeout(function () {
      $("#confirm-team-removal").modal();
    });
  }

  toggleRemoveUser(jobbler, index) {
    var _this = this;
    _this.popup_jobbler = jobbler;
    _this.index = index;
    _this.$timeout(function () {
      $("#modal-del-user-team").modal();
    });
  }

  keepUser() {
    var _this = this;
    _this.$timeout(function () {
      $("#modal-del-user-team").modal("toggle");
    });
  }

  toggleActionMenu(index) {
    var _this = this;
    let i = index + 1;

    _this.$timeout(function () {
      $("table.jobs-dashboard-jobs-table tbody tr:nth-child(" + i + ") td:last-child .action-menu").slideToggle({duration: 100});
    });

    _this.$timeout(function () {
      $("table.jobs-dashboard-jobs-table tbody tr:nth-child(" + i + ") td").addClass("row-focus");
    }, 150);

    _this.$timeout(function () {
      $("table.jobs-dashboard-jobs-table tbody tr:nth-child(" + i + ") td:last-child .action-menu").focus();
    }, 300);
  }

  closeActionMenu(index) {
    var _this = this;
    let i = index + 1;

    _this.$timeout(function () {
      $("table.jobs-dashboard-jobs-table tbody tr:nth-child(" + i + ") td:last-child .action-menu").hide();
      $("table.jobs-dashboard-jobs-table tbody tr:nth-child(" + i + ") td").removeClass("row-focus");
    }, 150);
  }

  removeUser() {
    var _this = this;
    let users_array = [];
    let data = {};
    data.users = _this.popup_jobbler.email;
    data.circle = parseInt(_this.$stateParams.teamId, 10);
    _this.setLoader();
    _this.$companies.deleteUserFromTeam(data).then(
      function (response) {
        //console.log("response");
        //console.dir(response);
        _this.unSetLoader();
        _this.jobblers.splice(_this.index, 1);
        let total = _this.$location.$$search.numberOfUsers - 1;
        _this.setPagination(total);
        _this.$timeout(function () {
          $("#modal-del-user-team").modal("toggle");
        });
      },
      function (error) {
        alert("There was an issue removing the jobbler from the team. Please try again. If the problem persists please contact support.");
      }
    );
  }

  formatNumber(number) {
    console.log("format number");
    let num = number;
    if (num) {
        if (num.charAt(0) === "1") {
          num = num.slice(1, num.length);
        }
        let cleaned = ("" + num).replace(/\D/g, "");
        var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
        if (match) {
          num = "(" + match[1] + ") " + match[2] + "-" + match[3];
        } else {
          num = num;
        }
      } else {
        num = "--";
      }
      return num;
  }

  setLoader() {
    var _this = this;
    _this.$timeout(function () {
      $("html").addClass("wait");
    });
  }

  unSetLoader() {
    var _this = this;
    _this.$timeout(function () {
      $("html").removeClass("wait");
    });
  }
}

TeamdetailsController.$inject = [
  "$http",
  "$localStorage",
  "$state",
  "auth",
  "teams",
  "companies",
  "security",
  "$stateParams",
  "common",
  "$rootScope",
  "env",
  "$timeout",
  "$location",
];

export default TeamdetailsController;



// WEBPACK FOOTER //
// ./client/app/components/teamdetails/teamdetails.controller.js